import fetchApi from '../utilities/fetch/httpService'
import apiUrls  from '../utilities/consts/apiUrls'

export const getProducts = () =>
  fetchApi({
    url: apiUrls.products.list_all,
    method: 'get'
  })

export const getProduct = (id) =>
  fetchApi({
    url: apiUrls.products.by_id.replace('$id', id),
    method: 'get'
  })
